<ng-container *ngIf="loading">
  <div class="loading-bar">
      <tm1-progress-ring value="" min="0" max="1" size="regular" ></tm1-progress-ring>
</div>
</ng-container>


<nav class="navbar navbar-expand-sm navbar-dark bg-dark">
  <div class="container-fluid">
    <a class="navbar-brand" href="#">Attendance Reporting</a>

    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div id="navbarContent" class="collapse navbar-collapse">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <ng-container *ngIf="!(isLoggedin | async); else loggedIn">
          <li class="nav-item">
            <a class="nav-link" routerLink="/login">Sign in</a>
          </li>
        </ng-container>
        <ng-template #loggedIn>
          <li *ngIf="ticketmaster | async">
            <a class="nav-link" routerLink="/dashboard" >Dashboard</a>
          </li>
          <li>
            <a class="nav-link" routerLink="/attendance" >Reports</a>
          </li>
          <li>
            <a class="nav-link" routerLink="/scanhistory" >Scan History</a>
          </li>
          <li *ngIf="(ticketmaster | async) || (admin | async) || (scan | async)">
            <a class="nav-link" routerLink="tools/barcodehistory" >Tools</a>
          </li>
          <li *ngIf="deliveryAdmin | async">
            <a class="nav-link" routerLink="feeds" >Attendance Feeds</a>
          </li>
          <li *ngIf="venueAdmin | async">
            <a class="nav-link" (click)="loadingStatus()" routerLink="users/search">User Management</a>
          </li>
          <li *ngIf="globalAdmin | async">
            <a class="nav-link" (click)="loadingStatus()" routerLink="performance">Performance</a>
          </li>
          <li *ngIf="globalAdmin | async">
            <a class="nav-link" (click)="loadingStatus()" routerLink="admin">Admin</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/login" (click)="signOut()">Log Out</a>
          </li>
        </ng-template>
      </ul>
      <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <span class="nav-link text-light" (click)="toggleModernView()">Version 2.1.4</span>
        </li>
      </ul>
    </div>
  </div>
</nav>

  <router-outlet></router-outlet>
  